import api from '@/api'
import axios from 'axios'
import request from '@/api/helpers/request'

/**
 *
 * @param phoneUrl - endpoint для отправки номера
 * @param checkCodeUrl - endpoint для отправки кода для проверки
 * @constructor
 */
export default function AuthService ({ phoneUrl, checkCodeUrl } = {}) {
  this.checkCodeUrl = checkCodeUrl
  this.phoneUrl = phoneUrl
  /**
   * @param phone - номер телефона в формате 380ххххххххх
   */
  this.verifyPhone = (phone) => {
    this.phone = phone
    return api.auth.verifyPhone({ phone, url: this.phoneUrl })
  }
  /**
   * @param code - код верификации
   * @param remember - флаг "Запомнить меня"
   */
  this.verifyCode = async ({ code, remember }) => {
    if (this.phone) {
      const phone = this.phone
      const source = window.location.href.includes('checkout') ? 'checkout' : 'default'
      try {
        const response = await api.auth.verifyCode({ phone, url: this.checkCodeUrl, code, remember, source })
        // обновляем csrf token после авторизации
        if (response.csrf) {
          axios.defaults.headers.common['x-csrf-token'] = response.csrf
          request.defaults.headers.common['x-csrf-token'] = response.csrf
        }
        return response
      } catch (e) {
        return e
      }
    }
  }
}
